{
  "es": {
    "issue_status": {
      "actions": {
        "create": "Crear estado de incidencia"
      },
      "labels": {
        "backup_status": "Estado de sustitución",
        "customer_status": "El cliente verá",
        "delete_status": "¿Eliminar el estado «{name}»?",
        "delete_status_disclaimer": "Todas las incidencias de posventa con este estado se reasignarán al estado que selecciones a continuación.",
        "inbox_hint": "Estado predeterminado de la bandeja de entrada",
        "internal_status": "Estado interno",
        "new_issue_status": "Estado"
      }
    }
  }
}
